import * as React from 'react';

import Grading from 'bundles/widget-simulator/components/tools/Grading';
import ScopeEditor from 'bundles/widget-simulator/components/tools/ScopeEditor';
import SessionConfigurationEditor from 'bundles/widget-simulator/components/tools/SessionConfigurationEditor';
import RpcActionLog from 'bundles/widget-simulator/components/tools/log/RpcActionLog';

import 'css!./__styles__/Sidebar';

const Sidebar = () => {
  return (
    <div className="rc-Sidebar">
      <ScopeEditor />
      <SessionConfigurationEditor />
      <Grading />
      <RpcActionLog />
    </div>
  );
};

export default Sidebar;
